import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { exportToCsv } from "@/lib/csv";

// columns: [{ label, key?, get?(row) }]
export function ExportButton({ filename, columns, rows, testId = "export-csv-button", disabled }) {
  const handleExport = () => {
    if (!rows || rows.length === 0) {
      toast("Nothing to export");
      return;
    }
    exportToCsv(filename, columns, rows);
    toast.success(`Exported ${rows.length} row(s) to CSV`);
  };
  return (
    <Button variant="outline" className="gap-2" onClick={handleExport} disabled={disabled} data-testid={testId}>
      <Download className="h-4 w-4" />
      Export CSV
    </Button>
  );
}
